import variable from "./../variables/platform";

export default (variables = variable) => {
  const pickerTheme = {};

  return pickerTheme;
};
